module.exports = __webpack_public_path__ + "static/media/green.db959ad6.png";